module.exports = __webpack_public_path__ + "img/postgre.1c4c146a.svg";